#import "../fragments/constant-contact-email-campaign-activity-preview.graphql"

query GetConstantContactEmailCampaignActivityPreview($id: ID!) {
    constantContactEmailCampaignActivityPreview(id: $id) {
        ...ConstantContactEmailCampaignActivityPreview
    }
}
